module.exports = __webpack_public_path__ + "img/Panama.7803d3b0.svg";